module.exports = __webpack_public_path__ + "static/IMG_20171123_175247.ed2d30d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/vol1/IMG_20171123_175247.jpg
// module id = 157
// module chunks = 106735565224735 162114328119038